import CoverPage from '../cover-page'

const NotFound = () => {
  return <CoverPage
    title='Error 404'
    subtitle='Page not found'
  />
}

export default NotFound